module.exports = __webpack_public_path__ + "img/prioritas_sameday_cod_k.6879c10e.png";